/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.1.0
 */

import { FC } from 'react';

import { icons } from '../../../assets';
import { ImgStyled } from '../Block/Img';
import { RangeMonthPickerButtonStyled } from './styled/RabgeMonthPickerButtonStyled';

interface IRangeMonthPickerButtonProps {
    label: string;
}

const RangeMonthPickerButton: FC<IRangeMonthPickerButtonProps> = props => (
    <RangeMonthPickerButtonStyled
        data-name='rangeMonthPickerButton'
    >
        {props.label}
        <ImgStyled className="drop-down-btn__icon small" src={icons.calendarIcon}/>
    </RangeMonthPickerButtonStyled>
);

export default RangeMonthPickerButton;
